module.exports = __webpack_public_path__ + "static/img/clothing_06.1c29605.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_06.png
// module id = nPY3
// module chunks = 0